module.exports = __webpack_public_path__ + "img/glossary-suijin2.7262c2ea.png";